export default __webpack_public_path__ + "static/media/publicationsMobile.09f15132.png";